import { all } from 'redux-saga/effects'
import { configSaga } from './config'
import { eventSaga } from './event'

export function* rootSaga() {
  yield all([
    eventSaga(),
    configSaga(),
  ])
}
